/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="34"
    height="45"
    viewBox="0 0 34 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M28.2181 23.6162C28.2004 20.3906 29.6701 17.9561 32.6451 16.1631C30.9806 13.7988 28.466 12.498 25.1457 12.2432C22.0024 11.9971 18.567 14.0625 17.3097 14.0625C15.9816 14.0625 12.9358 12.3311 10.5451 12.3311C5.60452 12.4102 0.354004 16.2422 0.354004 24.0381C0.354004 26.3408 0.779004 28.7197 1.629 31.1748C2.76234 34.4004 6.85296 42.3105 11.1207 42.1787C13.3519 42.126 14.928 40.6055 17.8321 40.6055C20.6478 40.6055 22.1087 42.1787 24.5967 42.1787C28.8998 42.1172 32.6009 34.9277 33.6811 31.6934C27.9082 28.9951 28.2181 23.7832 28.2181 23.6162ZM23.2066 9.18457C25.6238 6.33691 25.4024 3.74414 25.3316 2.8125C23.1978 2.93555 20.7274 4.25391 19.3196 5.87988C17.7701 7.62012 16.8582 9.77344 17.053 12.1992C19.3639 12.375 21.4712 11.1973 23.2066 9.18457Z" />
  </svg>
);
